import { TablePagination as MUITablePagination } from '@mui/material';
import { ChangeEvent as ReactChangeEvent, MouseEvent as ReactMouseEvent } from 'react';
import { TableInstance } from 'react-table';
import PaginationActions from './pagination-actions';

type TablePaginationProps<T extends object> = {
    total: number;
    instance: TableInstance<T>;
};
export default function TablePagination<T extends object>({ instance, total }: TablePaginationProps<T>) {
    const {
        state: { pageIndex, pageSize },
        gotoPage,
        setPageSize,
    } = instance;
    const handleChangePage = (event: ReactMouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => {
        gotoPage(page);
    };

    const handleChangeRowsPerPage = (event: ReactChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPageSize(Number(event.target.value));
    };
    return total ? (
        <MUITablePagination
            sx={{ display: 'flex', justifyContent: 'left' }}
            rowsPerPageOptions={[10, 25, 50]}
            count={total}
            page={pageIndex}
            rowsPerPage={pageSize}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={PaginationActions}
        />
    ) : null;
}
